export default {
  Success: 'Cập nhật thành công',
  Error: 'Đã có lỗi xảy ra, vui lòng liên hệ MISA để được hỗ trợ.',
  ChangesCannotBeSave: 'Các thay đổi không được lưu lại',
  ConfirmSave: 'Cảnh báo đã thay đổi, xác nhận có muốn lưu hay không?',
};